'use client';

import { useEffect } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { Button, Text } from '@holistic/components';
import { AlertCircle, RefreshCw } from '@holistic/components/icons';

import '@/app/globals.css';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Unhandled Global Root Layout Error:', error);
  }, [error]);

  return (
    <html lang="tr">
      <body className="bg-background flex min-h-screen flex-col items-center justify-center p-6 text-center">
        <div className="relative flex w-full max-w-lg flex-col items-center gap-6">
          <Link href="/" className="shrink-0">
            <Image
              src="/yeniden-siyah-logo.svg"
              alt="Yeniden.co"
              width={1011}
              height={214}
              className="h-7 w-auto"
              priority
            />
          </Link>

          <div className="relative flex items-center justify-center">
            <Text
              element="h1"
              className="from-destructive to-destructive/40 bg-linear-to-b bg-clip-text text-[7rem] leading-none font-black tracking-tighter text-transparent select-none sm:text-[10rem]"
            >
              500
            </Text>
            <span className="bg-background border-destructive/20 absolute -top-2 -right-2 flex h-14 w-14 animate-pulse items-center justify-center rounded-full border shadow-lg sm:h-16 sm:w-16">
              <AlertCircle className="text-destructive h-7 w-7 sm:h-8 sm:w-8" />
            </span>
          </div>

          <div className="flex flex-col items-center gap-2">
            <Text element="h2" className="text-2xl font-semibold">
              Kritik Sistem Hatası
            </Text>
            <Text
              element="p"
              className="text-muted-foreground max-w-md text-sm leading-relaxed"
            >
              Uygulama yüklenirken beklenmeyen bir hata oluştu. Sayfayı
              yenileyerek tekrar deneyebilirsiniz.
            </Text>
          </div>

          <div className="mt-2 flex items-center justify-center gap-3">
            <Button className="cursor-pointer gap-2" onClick={() => reset()}>
              <RefreshCw className="h-4 w-4" />
              Yeniden Dene
            </Button>
          </div>
        </div>
      </body>
    </html>
  );
}
